// @flow
import * as React from 'react';
import { CalcDrugFrequencyPeriod, FrequencyPeriod } from '@coverright/data-access/types/medicare';
import { MenuItem } from '@mui/material';
import { SelectInput } from '@coverright/ui/inputs';

type Props = {
  purchaseFrequency?: FrequencyPeriod,
  frequency?: string,
  onChange: (value: FrequencyPeriod) => void,
};

export function PurchaseFrequencySelect(props: Props) {
  return (
    <SelectInput
      label={'Purchase frequency'}
      placeholder={'Please select'}
      data-test={'purchase-frequency-select'}
      className={'mb-0'}
      value={props.purchaseFrequency || FrequencyPeriod.Monthly}
      hideTick
      MenuProps={{sx: {zIndex: 1502}}}
      onChange={(event) => {
        props.onChange(event.target.value as FrequencyPeriod);
      }}
    >
      <MenuItem
        value={FrequencyPeriod.Monthly}
        className={'regular'}
        disabled={
          props.frequency === CalcDrugFrequencyPeriod.Quarterly ||
          props.frequency === CalcDrugFrequencyPeriod.HalfYearly ||
          props.frequency === CalcDrugFrequencyPeriod.Yearly
        }
      >
        Monthly
      </MenuItem>

      <MenuItem value={FrequencyPeriod.Quarterly}
                disabled={
                  props.frequency === CalcDrugFrequencyPeriod.HalfYearly || props.frequency === CalcDrugFrequencyPeriod.Yearly
                }
                className={'regular'}>
        Quarterly
      </MenuItem>

      <MenuItem value={FrequencyPeriod.HalfYearly}
                disabled={
                  props.frequency === CalcDrugFrequencyPeriod.Yearly
                }
                className={'regular'}>
        Half Yearly
      </MenuItem>

      <MenuItem value={FrequencyPeriod.Yearly} className={'regular'}>
        Yearly
      </MenuItem>

    </SelectInput>
  );
}
